import { useForm } from 'react-hook-form'
import { useTranslation } from 'libs/i18n'
import { Link } from 'libs/router'
import { AuthCard, Button } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { ResetPasswordReqBody } from './types'
import { usePasswordValidationSchema } from './hooks/usePasswordValidationSchema'
import { useResetPasswordMutation } from './mutations/useResetPasswordMutation'

const PasswordResetTokenPage = () => {
	const { t } = useTranslation()
	const validationResolver = usePasswordValidationSchema()

	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({
		mode: 'onChange',
		resolver: validationResolver
	})
	const { resetPasswordMutation, isResetPasswordLoading, isResetPasswordSuccess } =
		useResetPasswordMutation()

	const onSubmit = (data: ResetPasswordReqBody) => {
		resetPasswordMutation(data)
	}

	return (
		<AuthCard
			title={t('Reset password')}
			description={t('Choose a new password for your account.')}
			footer={
				<Link className="font-medium text-primary hover:underline" to="/">
					{t('Continue to your account')}
				</Link>
			}>
			{isResetPasswordSuccess ? (
				<p className="rounded-md border border-success/40 bg-success-soft p-4 text-sm font-semibold text-success">
					{t('Password changed')}
				</p>
			) : (
				<form className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
					<InputGroup
						id="password"
						type="password"
						label={t('New password')}
						autoComplete="new-password"
						{...register('password')}
						error={(errors as any).password}
					/>
					<InputGroup
						id="password2"
						type="password"
						label={t('Confirm new password')}
						placeholder={t('Repeat the password')}
						autoComplete="new-password"
						{...register('password2')}
						error={(errors as any).password2}
					/>
					<Button
						type="submit"
						isLoading={isResetPasswordLoading}
						className="h-10 w-full rounded-md px-4 text-sm font-medium shadow">
						{t('Reset password')}
					</Button>
				</form>
			)}
		</AuthCard>
	)
}

export default PasswordResetTokenPage
